import * as React from 'react';

import type * as api from '@gitbook/api-client';
import type * as analytics from '@gitbook/app-analytics/client';

/**
 * React context for the space screen.
 */
export const SpaceContext = React.createContext<null | {
    space: api.Space;
    changeRequest: api.ChangeRequest | null;
    analyticsContext: analytics.AnalyticsContextSpaceContent;
    readOnly: boolean;
}>(null);
